import { TextField, TextFieldProps } from "@material-ui/core";
import { forwardRef } from "react";
import * as S from "./styles";

export type InputProps = TextFieldProps & {
  customLabel?: string;
};

export const Input = forwardRef<HTMLDivElement, InputProps>(
  function Input(
    {
      fullWidth = true,
      variant = "outlined",
      customLabel,
      value = "",
      ...rest
    },
    ref
  ) {
    return (
      <S.Container>
        <label>
          {customLabel}

          <TextField
            variant={variant}
            {...rest}
            fullWidth={fullWidth}
            value={value}
            ref={ref}
          />
        </label>
      </S.Container>
    );
  }
);
